import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconPlus: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#00795B',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4584 9.99999C16.4584 10.345 16.1784 10.625 15.8334 10.625H10.6251V15.8333C10.6251 16.1783 10.3451 16.4583 10.0001 16.4583C9.65508 16.4583 9.37508 16.1783 9.37508 15.8333V10.625H4.16675C3.82175 10.625 3.54175 10.345 3.54175 9.99999C3.54175 9.65499 3.82175 9.37499 4.16675 9.37499H9.37508V4.16666C9.37508 3.82166 9.65508 3.54166 10.0001 3.54166C10.3451 3.54166 10.6251 3.82166 10.6251 4.16666V9.37499H15.8334C16.1784 9.37499 16.4584 9.65499 16.4584 9.99999Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconPlus;
